import { useEffect, useRef, useState } from 'react';
import './VideoMask.css';

/**
 * The hero video treatment: a black-and-white base layer with two colour copies
 * of the same file clipped into roaming windows, plus its own loading spinner so
 * a slow video download never gates the rest of the page.
 *
 * Always muted — autoplay policy blocks anything with sound, and a marketing
 * hero should never make noise.
 */
export default function VideoMask({ src = '/video.mp4', className = '', ratio }) {
  const base = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const vids = Array.from(document.querySelectorAll('.rw-vm video'));
    vids.forEach((v) => {
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;
      v.loop = true;
      v.playsInline = true;
      v.onvolumechange = () => { if (!v.muted || v.volume) { v.muted = true; v.volume = 0; } };
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    });

    const v = base.current;
    if (!v) return undefined;
    if (v.readyState >= 3) { setReady(true); return undefined; }
    const done = () => setReady(true);
    v.addEventListener('canplay', done);
    v.addEventListener('loadeddata', done);
    v.addEventListener('error', done);
    return () => {
      v.removeEventListener('canplay', done);
      v.removeEventListener('loadeddata', done);
      v.removeEventListener('error', done);
    };
  }, [src]);

  return (
    <div className={'rw-vm ' + className} style={ratio ? { aspectRatio: ratio } : undefined}>
      <div className="rw-vm__base rw-grayscale">
        <video ref={base} src={src} autoPlay playsInline preload="auto" />
      </div>
      <video className="rw-vm__win rw-vm__win--1" src={src} autoPlay playsInline preload="auto" aria-hidden="true" />
      <video className="rw-vm__win rw-vm__win--2" src={src} autoPlay playsInline preload="auto" aria-hidden="true" />
      {!ready && (
        <div className="rw-vm__loading">
          <span className="rw-spinner" />
          <span className="rw-spinner__label">Loading video</span>
        </div>
      )}
    </div>
  );
}
